'use client';
import { useState } from 'react';

import {
  IconMoveAlt,
  IconSliders,
  IconSprayBottle,
  IconUsbDongle,
} from '@veneer/core';
import { useTranslation } from 'react-i18next';

import { NamespacesI18n } from '@storefront/i18n';

import styles from './index.module.scss';
import { ModalAccessories } from '../index';

const IconMap = {
  featureKeys: IconSliders,
  featureWireless: IconUsbDongle,
  featureMultiSurface: IconMoveAlt,
  featureCleaning: IconSprayBottle,
};

interface Features {
  [key: string]: {
    label: string;
  };
}

interface ModalMouseKeyboardProps {
  model?: string;
}

export const ModalMouseKeyboard = () => {
  const i18nPrefix = 'pc.modalKeyboardMouse';
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: i18nPrefix,
  });
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const features: Features[] = t('featuresList', { returnObjects: true });

  return (
    <>
      <ModalAccessories
        title="modal-mouse-keyboard"
        show={showModal}
        className={styles['modal-container']}
        i18nPrefix={i18nPrefix}
        styles={styles}
        featuresImg={{
          src: 'modal_keyboard_1.png',
          alt: 'keyboard and mouse',
          width: 400,
          height: 0,
          quality: 100,
          className: styles['vertical-image'],
        }}
        bottomImg={{
          src: 'modal_keyboard_2.png',
          alt: 'keyboard and mouse',
          width: 920,
          height: 0,
          quality: 100,
          className: styles['horizontal-image'],
        }}
        features={
          <div>
            <p className={`title-regular ${styles['title']}`}>
              {t('features')}
            </p>
            <ul className={styles['list']}>
              {features.map((feature) => {
                const [key, item] = Object.entries(feature)[0];
                const Icon = IconMap[key as keyof typeof IconMap];
                return (
                  <li
                    className={`${styles.feature} subtitle-regular`}
                    key={key}
                  >
                    {Icon ? <Icon size={24} /> : null}
                    {item.label}
                  </li>
                );
              })}
            </ul>
          </div>
        }
        onClose={handleClose}
      />
      <input
        id="open-modal-mouse-keyboard"
        data-testid="modal-mouse-keyboard"
        tabIndex={0}
        className={styles['modal-button']}
        aria-label="modal mouse keyboard"
        type="button"
        value={t('link')}
        onClick={async () => {
          setShowModal(true);
        }}
      />
    </>
  );
};
